// app/javascript/controllers/overscroll_controller.js
import { Controller } from "@hotwired/stimulus"

const SCROLL_THRESHOLD = 50

export default class extends Controller {
  connect() {
    this.active = undefined
    this.rafId = 0
    this.onScroll = () => this.scheduleUpdate()

    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)

    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
      this.rafId = 0
    }

    document.documentElement.classList.remove("no-overscroll")
  }

  scheduleUpdate() {
    if (this.rafId) return
    this.rafId = requestAnimationFrame(() => {
      this.rafId = 0
      this.update()
    })
  }

  update() {
    const active = window.scrollY > SCROLL_THRESHOLD

    if (this.active === active) return

    this.active = active
    document.documentElement.classList.toggle("no-overscroll", active)
  }
}
